import { render, staticRenderFns } from "./import-blend.vue?vue&type=template&id=71706bac&scoped=true"
import script from "./import-blend.vue?vue&type=script&lang=js"
export * from "./import-blend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71706bac",
  null
  
)

export default component.exports